var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 705,
    viewBox: "0 0 456 705",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_149)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.307,
    y: 409.101,
    width: 19.009,
    height: 63.3632,
    transform: "rotate(-34.304 291.307 409.101)",
    fill: "#E1F4E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.094,
    cy: 306.912,
    r: 123.558,
    transform: "rotate(-34.304 233.094 306.912)",
    fill: "url(#paint0_linear_36_149)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.094,
    cy: 306.912,
    r: 104.549,
    transform: "rotate(-34.304 233.094 306.912)",
    fill: "url(#paint1_linear_36_149)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.55,
    cx: 277.99,
    cy: 325.891,
    rx: 70.2984,
    ry: 50.5508,
    transform: "rotate(-70.1978 277.99 325.891)",
    fill: "url(#paint2_linear_36_149)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_36_149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6381,
    cy: 288.026,
    rx: 11.1852,
    ry: 6.50778,
    transform: "rotate(100.696 27.6381 288.026)",
    fill: "url(#paint3_linear_36_149)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_36_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.294 277.145L132.075 252.911C131.392 252.255 130.344 252.167 129.562 252.701L122.229 257.704C121.425 258.252 121.133 259.299 121.536 260.185L135.806 291.516C137.007 294.153 136.46 297.257 134.429 299.323L106.938 327.305C106.269 327.987 106.174 329.046 106.712 329.834L111.347 336.627C111.902 337.44 112.966 337.728 113.856 337.307L148.726 320.769C151.453 319.476 154.701 320.076 156.786 322.257L181.643 348.267C182.319 348.974 183.408 349.088 184.216 348.537L191.526 343.549C192.314 343.012 192.613 341.994 192.241 341.117L177.996 307.506C176.857 304.82 177.504 301.71 179.62 299.7L206.082 274.559C207.148 273.545 207.323 271.908 206.494 270.693L202.788 265.261C201.985 264.084 200.464 263.634 199.15 264.185L164.849 278.554C162.275 279.633 159.307 279.079 157.294 277.145Z",
    fill: "url(#paint4_linear_36_149)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.926 282.546L130.15 255.719C129.071 254.501 127.254 254.276 125.909 255.193C124.532 256.133 124.095 257.965 124.9 259.425L141.945 290.343C144.219 294.467 143.307 299.62 139.755 302.713L109.561 329.002C108.338 330.066 108.106 331.876 109.019 333.215C109.957 334.59 111.794 335.016 113.241 334.193L147.507 314.713C151.731 312.312 157.069 313.294 160.162 317.041L183.587 345.424C184.646 346.708 186.509 346.972 187.884 346.034C189.228 345.117 189.676 343.342 188.929 341.897L171.792 308.741C169.618 304.535 170.692 299.381 174.365 296.393L204.014 272.271C205.307 271.219 205.579 269.352 204.64 267.976C203.726 266.636 201.956 266.19 200.516 266.935L166.006 284.795C161.939 286.899 156.962 285.973 153.926 282.546Z",
    fill: "url(#paint5_linear_36_149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.393 300.111C430.141 286.55 424.834 270.688 424.062 254.289L419.589 159.33C418.877 144.221 409.277 130.971 395.141 125.588L352.09 109.197C350.836 108.719 350.163 107.355 350.546 106.069C350.96 104.683 352.438 103.913 353.811 104.37L406.609 121.925C421.179 126.77 431.404 139.902 432.53 155.215L439.11 244.74C440.255 260.323 445.496 275.326 454.301 288.233L494.511 347.169L478.809 357.882L439.393 300.111Z",
    fill: "url(#paint6_linear_36_149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.393 300.111C430.141 286.55 424.834 270.688 424.062 254.289L419.589 159.33C418.877 144.221 409.277 130.971 395.141 125.588L352.09 109.197C350.836 108.719 350.163 107.355 350.546 106.069C350.96 104.683 352.438 103.913 353.811 104.37L406.609 121.925C421.179 126.77 431.404 139.902 432.53 155.215L439.11 244.74C440.255 260.323 445.496 275.326 454.301 288.233L494.511 347.169L478.809 357.882L439.393 300.111Z",
    fill: "#E1F4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.219 358.83C463.603 355.964 464.449 352.338 467.167 350.484L491.868 333.631C494.586 331.777 498.271 332.311 500.35 334.862L579.132 431.494C590.978 446.025 587.851 467.58 572.365 478.146C556.879 488.712 535.668 483.761 526.459 467.431L465.219 358.83Z",
    fill: "url(#paint7_linear_36_149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.219 358.83C463.603 355.964 464.449 352.338 467.167 350.484L491.868 333.631C494.586 331.777 498.271 332.311 500.35 334.862L579.132 431.494C590.978 446.025 587.851 467.58 572.365 478.146C556.879 488.712 535.668 483.761 526.459 467.431L465.219 358.83Z",
    fill: "url(#paint8_linear_36_149)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.219 358.83C463.603 355.964 464.449 352.338 467.167 350.484L491.868 333.631C494.586 331.777 498.271 332.311 500.35 334.862L579.132 431.494C590.978 446.025 587.851 467.58 572.365 478.146C556.879 488.712 535.668 483.761 526.459 467.431L465.219 358.83Z",
    fill: "#E1F4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.428 462.391C311.812 459.525 312.658 455.899 315.376 454.044L340.077 437.192C342.795 435.337 346.48 435.872 348.559 438.422L427.341 535.055C439.187 549.585 436.06 571.141 420.574 581.707C405.088 592.272 383.877 587.321 374.668 570.991L313.428 462.391Z",
    fill: "#E3F9E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.428 462.391C311.812 459.525 312.658 455.899 315.376 454.044L340.077 437.192C342.795 435.337 346.48 435.872 348.559 438.422L427.341 535.055C439.187 549.585 436.06 571.141 420.574 581.707C405.088 592.272 383.877 587.321 374.668 570.991L313.428 462.391Z",
    fill: "url(#paint9_linear_36_149)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_36_149",
    x: 16.913,
    y: 272.968,
    width: 21.4501,
    height: 30.116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_36_149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_36_149",
    x: 102.365,
    y: 248.353,
    width: 108.651,
    height: 104.532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_36_149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_149",
    x1: 233.094,
    y1: 183.354,
    x2: 233.094,
    y2: 430.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F4E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36_149",
    x1: 233.094,
    y1: 202.363,
    x2: 233.094,
    y2: 411.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36_149",
    x1: 274.37,
    y1: 252.849,
    x2: 275.594,
    y2: 414.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_36_149",
    x1: 23.6567,
    y1: 285.392,
    x2: 23.9864,
    y2: 298.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_36_149",
    x1: 125.871,
    y1: 255.219,
    x2: 187.847,
    y2: 346.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_36_149",
    x1: 125.871,
    y1: 255.219,
    x2: 187.847,
    y2: 346.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_36_149",
    x1: 551.408,
    y1: 337.162,
    x2: 337.33,
    y2: 149.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_36_149",
    x1: 499.364,
    y1: 432.983,
    x2: 553.519,
    y2: 399.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#D6D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8574F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_36_149",
    x1: 566.177,
    y1: 474.697,
    x2: 523.324,
    y2: 411.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9080F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648933,
    stopColor: "#9080F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_36_149",
    x1: 327.727,
    y1: 445.618,
    x2: 333.083,
    y2: 453.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 506.906,
    height: 506.906,
    fill: "white",
    transform: "translate(0 285.684) rotate(-34.304)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.3e24a4c21b7185fe79616006bbd73295.svg";
export { ForwardRef as ReactComponent };